export const addPrefixNameToFormName = (name: string, prefixName?: string) => (prefixName ? `${prefixName}.${name}` : name)
